<template>
  <teleport to="body">
    <div class="fixed right-[50px] bottom-[100px] z-5 flex flex-col gap-2">
      <div
        class="flex size-[56px] cursor-pointer items-center justify-center rounded-lg bg-white transition-colors duration-200 hover:bg-[#3C3C3C] dark:bg-[#2C2C2C]"
        @click="handleChatClick"
      >
        <el-icon size="24px" :color="isDark ? 'white' : 'black'">
          <ChatLineRound />
        </el-icon>
      </div>
      <div
        class="flex size-[56px] cursor-pointer items-center justify-center rounded-lg bg-white transition-colors duration-200 hover:bg-[#3C3C3C] dark:bg-[#2C2C2C]"
        @click="handleHeadsetClick"
      >
        <el-icon size="24px" :color="isDark ? 'white' : 'black'">
          <Headset />
        </el-icon>
      </div>

      <el-badge :value="12" class="item">
        <div
          class="flex size-[56px] cursor-pointer items-center justify-center rounded-lg bg-white transition-colors duration-200 hover:bg-[#3C3C3C] dark:bg-[#2C2C3C]"
          @click="handleUploadClick"
        >
          <el-icon size="24px" :color="isDark ? 'white' : 'black'">
            <UploadFilled />
          </el-icon>
        </div>
      </el-badge>
    </div>
  </teleport>
</template>

<script setup>
import { ChatLineRound, Headset, UploadFilled } from "@element-plus/icons-vue";
const { isDark } = useTheme();

const emit = defineEmits(["chat-click", "headset-click", "upload-click"]);

const handleChatClick = () => {
  emit("chat-click");
};

const handleHeadsetClick = () => {
  emit("headset-click");
};

const handleUploadClick = () => {
  emit("upload-click");
};
</script>

<style scoped>
/* 可以在这里添加额外的样式 */
</style>
